var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.857,
    height: 21.763,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1034",
    d: "M0 2.564A2.332 2.332 0 012.35.214h11.965a2.137 2.137 0 110 4.273H4.7v4.548h8.241a2.137 2.137 0 010 4.273H4.7v6.1a2.35 2.35 0 01-4.7 0zm22.463-.183a2.35 2.35 0 014.7 0v14.925h8.7a2.137 2.137 0 110 4.273h-11.05a2.332 2.332 0 01-2.35-2.35zm23.258 10.958l-6.9-9.37a2.786 2.786 0 01-.58-1.679 2.294 2.294 0 012.35-2.259 2.705 2.705 0 012.32 1.435L48.1 8.944l5.28-7.539a2.694 2.694 0 012.259-1.4 2.178 2.178 0 012.289 2.289 2.919 2.919 0 01-.611 1.648l-6.9 9.31v6.166a2.35 2.35 0 11-4.7 0zM63.576 2.565a2.332 2.332 0 012.35-2.35h6.379c5.1 0 8.18 3.022 8.18 7.387v.061c0 4.945-3.846 7.509-8.638 7.509h-3.57v4.243a2.351 2.351 0 01-4.7 0zm8.425 8.424c2.35 0 3.724-1.4 3.724-3.236v-.061c0-2.106-1.466-3.235-3.816-3.235h-3.632v6.532zm14.406 8.241V2.564a2.332 2.332 0 012.35-2.35H100.6a2.11 2.11 0 012.107 2.106 2.085 2.085 0 01-2.107 2.076h-9.523v4.333h8.15a2.111 2.111 0 012.106 2.106 2.084 2.084 0 01-2.106 2.075h-8.15v4.487h9.676a2.11 2.11 0 012.106 2.106 2.085 2.085 0 01-2.106 2.076h-12a2.332 2.332 0 01-2.348-2.35z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed4d71627f65bb022baf4547d2831893.svg";
export { ForwardRef as ReactComponent };